import { Doc, Printer } from "components";
import clsx from "clsx";
import { useMemo, forwardRef } from "react";
import { useLocale } from "hooks";
import PersonsComponent from "views/Persons/PersonsComponent";
import FaqComponent from "views/FAQ/components/FaqComponent";
import ResearchCenterListComponent from "views/ResearchCenter/components/ResearchCenterListComponent";
import LabeledListRenderer from "views/ResearchCenter/components/LabeledListRenderer";
import TabNewsRenderer from "../TabNewsRenderer/TabNewsRenderer";
import translation from "./translation";
import CareerList from "./CareersList";
import TabCoursesRenderer from "../TabCoursesRenderer";
import TabGraduatedsRenderer from "../TabGraduatedsRenderer";
import ActiveOrDeactiveListComponent from "views/ResearchCenter/components/ActiveOrDeactiveListComponent";
import OrganizationRenderer from "./OrganizationRenderer";

const TabConentRenderer = forwardRef(
  ({ tabs, activeTab, className, componentRef }, ref) => {
    const { locale, isRTL } = useLocale();
    const renderTabContent = useMemo(() => {
      // if (!activeTab) {
      //   return (
      //     <div className="tw-px-4 md:tw-px-0">
      //       <div className="tw-bg-white tw-rounded-2xl tw-mt-[50px] tw-p-5">
      //         <div className="tw-text-center">
      //           {translation[locale]?.NO_CONTENT}
      //         </div>
      //       </div>
      //     </div>
      //   );
      // }
      return tabs?.map?.((t) => {
        if (t?.tagtreeId) {
          return (
            <div
              className={clsx(
                "tw-transition-opacity tw-duration-300 tw-px-4 md:tw-px-0",
                {
                  "tw-opacity-0 !tw-h-0 !tw-overflow-hidden":
                    activeTab?.slug !== t?.slug,
                  "tw-mt-4 tw-opacity-100": activeTab?.slug === t?.slug,
                },
                className
              )}
            >
              <OrganizationRenderer tabData={t} />
            </div>
          );
        }
        if (t?.coursesTagTree) {
          return (
            <div
              className={clsx(
                "tw-transition-opacity tw-duration-300 tw-px-4 md:tw-px-0",
                {
                  "tw-opacity-0 !tw-h-0 !tw-overflow-hidden":
                    activeTab?.slug !== t?.slug,
                  "tw-mt-4 tw-opacity-100": activeTab?.slug === t?.slug,
                },
                className
              )}
            >
              <TabCoursesRenderer tagTree={t?.coursesTagTree} />
            </div>
          );
        }

        if (t?.newsTagTreeId) {
          return (
            <div
              className={clsx("tw-transition-opacity tw-duration-300", {
                "tw-opacity-0 !tw-h-0 !tw-overflow-hidden":
                  activeTab?.slug !== t?.slug,
                "tw-mt-5 tw-opacity-100": activeTab?.slug === t?.slug,
              })}
            >
              <TabNewsRenderer tagTreeId={t?.newsTagTreeId} />
            </div>
          );
        }

        if (t?.graduatesTagTree) {
          return (
            <div
              className={clsx(
                "tw-transition-opacity tw-duration-300 tw-px-4 md:tw-px-0",
                {
                  "tw-opacity-0 !tw-h-0 !tw-overflow-hidden":
                    activeTab?.slug !== t?.slug,
                  "tw-mt-4 tw-opacity-100": activeTab?.slug === t?.slug,
                },
                className
              )}
            >
              <TabGraduatedsRenderer tagTree={t?.graduatesTagTree} />
            </div>
          );
        }

        if (t?.careersTagTree) {
          return (
            <div
              className={clsx(
                "tw-transition-opacity tw-duration-300 tw-px-4 md:tw-px-0",
                {
                  "tw-opacity-0 !tw-h-0 !tw-overflow-hidden":
                    activeTab?.slug !== t?.slug,
                  "tw-mt-4 tw-opacity-100": activeTab?.slug === t?.slug,
                },
                className
              )}
            >
              <CareerList tagTree={t?.careersTagTree} pagination />
            </div>
          );
        }

        if (t?.podformLink) {
          return activeTab?.slug === t?.slug ? (
            <div
              className={clsx("tw-transition-opacity tw-duration-300", {
                "tw-opacity-0 !tw-h-0 !tw-overflow-hidden":
                  activeTab?.slug !== t?.slug,
                "tw-mt-[50px] tw-opacity-100": activeTab?.slug === t?.slug,
              })}
            >
              <iframe
                src={t.podformLink}
                width="100%"
                className="tw-h-screen"
                frameBorder={0}
              />
            </div>
          ) : (
            ""
          );
        }

        if (t?.personsTagTree) {
          return (
            <div
              className={clsx(
                "tw-transition-opacity tw-duration-300 tw-px-4 md:tw-px-0",
                {
                  "tw-opacity-0 !tw-h-0 !tw-overflow-hidden":
                    activeTab?.slug !== t?.slug,
                  "tw-mt-[50px] tw-opacity-100": activeTab?.slug === t?.slug,
                },
                className
              )}
            >
              <PersonsComponent personsTagTree={t?.personsTagTree} />
            </div>
          );
        }

        if (t?.faqTagTree) {
          return (
            <div
              className={clsx(
                "tw-transition-opacity tw-duration-300 tw-px-4 md:tw-px-0",
                {
                  "tw-opacity-0 !tw-h-0 !tw-overflow-hidden":
                    activeTab?.slug !== t?.slug,
                  "tw-mt-[50px] tw-opacity-100": activeTab?.slug === t?.slug,
                },
                className
              )}
            >
              <FaqComponent faqTagTree={t?.faqTagTree} showSearch={false} />
            </div>
          );
        }

        if (t?.researchcentersTagTree) {
          return (
            <div
              className={clsx(
                "tw-transition-opacity tw-duration-300 tw-px-4 md:tw-px-0",
                {
                  "tw-opacity-0 !tw-h-0 !tw-overflow-hidden":
                    activeTab?.slug !== t?.slug,
                  "tw-mt-[50px] tw-opacity-100": activeTab?.slug === t?.slug,
                },
                className
              )}
            >
              <ResearchCenterListComponent
                researchcentersTagTree={t?.researchcentersTagTree}
                pagination
              />
            </div>
          );
        }
        if (t?.countedListTagTree) {
          return (
            <div
              className={clsx(
                "tw-transition-opacity tw-duration-300 tw-px-4 md:tw-px-0",
                {
                  "tw-opacity-0 !tw-h-0 !tw-overflow-hidden":
                    activeTab?.slug !== t?.slug,
                  "tw-mt-[50px] tw-opacity-100": activeTab?.slug === t?.slug,
                },
                className
              )}
            >
              <LabeledListRenderer
                researchcentersTagTree={t?.countedListTagTree}
                pagination
              />
            </div>
          );
        }

        if (t?.activeListTagTree) {
          return (
            <div
              className={clsx(
                "tw-transition-opacity tw-duration-300 tw-px-4 md:tw-px-0",
                {
                  "tw-opacity-0 !tw-h-0 !tw-overflow-hidden":
                    activeTab?.slug !== t?.slug,
                  "tw-mt-[50px] tw-opacity-100": activeTab?.slug === t?.slug,
                },
                className
              )}
            >
              <ActiveOrDeactiveListComponent
                researchcentersTagTree={t?.activeListTagTree}
                pagination
                showActive
              />
            </div>
          );
        }

        if (t?.archivedListTagTree) {
          return (
            <div
              className={clsx(
                "tw-transition-opacity tw-duration-300 tw-px-4 md:tw-px-0",
                {
                  "tw-opacity-0 !tw-h-0 !tw-overflow-hidden":
                    activeTab?.slug !== t?.slug,
                  "tw-mt-[50px] tw-opacity-100": activeTab?.slug === t?.slug,
                },
                className
              )}
            >
              <ActiveOrDeactiveListComponent
                researchcentersTagTree={t?.archivedListTagTree}
                pagination
                showActive={false}
              />
            </div>
          );
        }

        return (
          <div className="tw-px-4 md:tw-px-0">
            <div
              className={clsx(
                "tw-transition-opacity tw-duration-300 tw-bg-white tw-rounded-2xl tw-overflow-x-auto",
                {
                  "tw-opacity-0 !tw-h-0 !tw-overflow-hidden":
                    activeTab?.slug !== t?.slug,
                  "tw-mt-[50px] tw-opacity-100 tw-p-5":
                    activeTab?.slug === t?.slug,
                }
              )}
            >
              {t?.content ? (
                <Doc ltr={!isRTL}>
                  <div className="doc">
                    <div dangerouslySetInnerHTML={{ __html: t?.content }}></div>
                    {/* {HtmlParser(t?.content)} */}
                  </div>
                </Doc>
              ) : (
                <div className="tw-text-center">
                  {translation[locale]?.NO_CONTENT}
                </div>
              )}
              <div className="tw-mt-[50px]">
                {componentRef && (
                  <Printer componentRef={componentRef} secondary />
                )}
              </div>
            </div>
          </div>
        );
      });
    }, [activeTab, tabs]);
    return renderTabContent;
  }
);

export default TabConentRenderer;
